import React from "react";
import Pill from "carbon-react/lib/components/pill";

const UserStatusPill = (props) => {
  return (
    <>
      {props.user.blocked === true ? (
        <Pill pillRole="status" colorVariant="negative" fill>
          Blocked
        </Pill>
      ) : (
        <Pill pillRole="status" colorVariant="positive" fill>
          Active
        </Pill>
      )}
    </>
  );
};

export default UserStatusPill;
